export default {
  /** 策略合同分配-获取分页查询列表 */
  LIST_PROCOMBI_CONTRACT_BY_PAGE: '/sales/procombiContract/queryPageList',
  /** 策略合同分配-策略合同新增 */
  PROCOMBI_CONTRACT_ADD: '/sales/procombiContract/procombiContractAdd',
  /** 策略合同分配-策略合同删除 */
  PROCOMBI_CONTRACT_DELETE: '/sales/procombiContract/procombiContractDel',
  /** 策略合同分配-策略合同导出 */
  PROCOMBI_CONTRACT_EXPORT: '/sales/procombiContract/procombiContractExport',
  /** 策略合同分配-策略合同分配详情查询 */
  QUERY_PROCOMBI_CONTRACT_LISTBYID: '/sales/procombiContract/queryListById',

  /**合同查询*/
  GET_LIST_API: '/sales/orderDetail/listOrderDetailByPage',

  /**策略信息-分页查询*/
  LIST_PROCOMBI_BY_PAGE: '/sales/procombi/queryPage',

  /**策略信息-多种策略-分页查询*/
  LIST_PROCOMBIS_BY_PAGE: '/sales/procombi/queryProcombiPage',

  /**套利策略持仓查询*/
  LIST_COMBIHOLDSINFO: '/sales/combiHoldsInfo/queryList',

  /**基差策略现货、期货查询*/
  LIST_BASISINFO: '/sales/combiHoldsInfo/queryForBasisStrategy',
};
